import React, { Component } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import AsideNavbarDummy from "../components/navbars/AsideNavbarDummy";
import DummyHomeNavbar from "../components/home/DummyHomeNavbar";
import * as Cookies from "es-cookie";
import { graphql } from "react-apollo";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import { FETCH_STUDENTGLOBALS, FETCH_ISSTUDENTUSERVALID } from "../../utils/studentSession";
import ContentLoader from "react-content-loader";

// Shared with the exam switcher, which reloads the same data.

// The enrollment id cookie set at login. Missing, or the text "null" /
// "undefined" when login returned none.
const hasEnrollmentId = () => !isNaN(parseInt(Cookies.get("student_user_exam_id")));

class StudentLoading extends Component {
  constructor(props) {
    super(props);
    this.queryTimers = {};
    this.queryLogged = {};
    this.startAll = Date.now();

    ["studentGlobals", "isStudentUserValid"].forEach((q) => {
      this.queryTimers[q] = Date.now();
      this.queryLogged[q] = false;
    });
  }

  componentDidUpdate(prevProps) {
    if (!hasEnrollmentId()) return;
    this.checkAndLogTime(prevProps, "studentGlobals");
    this.checkAndLogTime(prevProps, "isStudentUserValid");

    // If all queries done, log total time
    const allLoaded =
      !this.props.studentGlobals.loading &&
      !this.props.isStudentUserValid.loading;

    if (
      allLoaded &&
      Object.values(this.queryLogged).every((v) => v) &&
      !this.totalLogged
    ) {
      const total = Date.now() - this.startAll;
      console.log(`✅ All queries completed in ${total} ms`);
      this.totalLogged = true;
    }
  }

  checkAndLogTime(prevProps, queryName) {
    const prev = prevProps[queryName];
    const curr = this.props[queryName];
    if (prev.loading && !curr.loading && !this.queryLogged[queryName]) {
      const timeTaken = Date.now() - this.queryTimers[queryName];
      this.queryLogged[queryName] = true;
      console.log(`⏱ ${queryName} completed in ${timeTaken} ms`);
    }
  }

  menuToggler = () => {
    const toggled = Cookies.get("toggle");
    if (toggled === "wrapper") {
      this.setState({ toggled: "wrapper sidebar-enable" });
      Cookies.set("toggle", "wrapper sidebar-enable");
    } else {
      this.setState({ toggled: "wrapper" });
      Cookies.set("toggle", "wrapper");
    }
  };

  render() {
    // No session, or a session without an enrollment id (the queries below
    // would only fail with 400): start again from login.
    if (Cookies.get("studenttoken") == undefined || !hasEnrollmentId()) {
      this.props.history.push("/student/login");
      return null;
    }

    const { studentGlobals, isStudentUserValid } = this.props;

    const loading2 = studentGlobals.loading;
    const loading3 = isStudentUserValid.loading;

    const error2 = studentGlobals.error;
    const error3 = isStudentUserValid.error;

    if (error2 || error3) {
      console.error("GraphQL Query Error:", { error2, error3 });
      return null;
    }

    if (isStudentUserValid.isStudentUserValid != undefined) {
      if (isStudentUserValid.isStudentUserValid.estatus == 0) {
        Cookies.remove("token");
        Cookies.remove("username");
        Cookies.remove("refreshtoken");
        Cookies.remove("email");
        Cookies.remove("id");
        Cookies.remove("institutionid");
        Cookies.remove("userlevel");
        Cookies.remove("name");
        this.props.history.push("/student/login");
      }
    }

    localStorage.removeItem("studentglobals");
    localStorage.setItem(
      "studentglobals",
      JSON.stringify(studentGlobals.studentGlobals)
    );
    localStorage.setItem(
      "isStudentUserValid",
      JSON.stringify(isStudentUserValid.isStudentUserValid)
    );

    return (
      <div className={Cookies.get("toggle")}>
        <div className="student main-wrapper">
          {(loading2 || loading3) && (
            <>
              <div className="student header-area">
                <DummyHomeNavbar onClick={() => this.menuToggler()} />
              </div>
              <AsideNavbarDummy onClick={(e) => e.preventDefault()} />
              <div className="content-wrapper pt-0">
                <Container>
                  <section className="student-home">
                    {/* Subject placeholders */}
                    <Row className="student-subject-card">
                      {[1, 2, 3, 4].map((n) => (
                        <Col key={n} xl={3} lg={3} md={6} sm={12}>
                          <Card className="single-card shadow-sm border-0">
                            <Card.Body className="p-2">
                              <ContentLoader
                                viewBox="0 0 500 175"
                                height={175}
                                width="100%"
                                speed={2}
                              >
                                <rect x="30" y="30" rx="10" ry="10" width="70" height="70" />
                                <rect x="129.9" y="29.5" width="125.5" height="17" />
                                <rect x="129.9" y="64.7" width="296" height="17" />
                                <rect x="129.9" y="97.8" width="253.5" height="17" />
                                <rect x="129.9" y="132.3" width="212.5" height="17" />
                              </ContentLoader>
                            </Card.Body>
                          </Card>
                        </Col>
                      ))}
                    </Row>

                    {/* Large card placeholders */}
                    <Row>
                      {[1, 2, 3].map((n) => (
                        <Col key={n} xl={4} lg={4} md={12} sm={12}>
                          <Card className="my-3 border-0">
                            <div className="showcase-component">
                              <ContentLoader
                                speed={2}
                                width={400}
                                height={560}
                                viewBox="0 0 420 560"
                                backgroundColor="#f3f3f3"
                                foregroundColor="#ecebeb"
                              >
                                <rect x="8" y="14" rx="2" ry="2" width="400" height="560" />
                              </ContentLoader>
                            </div>
                          </Card>
                        </Col>
                      ))}
                    </Row>
                  </section>
                </Container>
              </div>
            </>
          )}

          {!loading2 && !loading3 && (
            <>
              {Cookies.get("institution_id") == 119 ? (
                this.props.history.push("/student/exams/schedule-exam")
              ) : studentGlobals?.studentGlobals?.loginRedirectionPath ? (
                this.props.history.push(
                  studentGlobals.studentGlobals.loginRedirectionPath
                )
              ) : (
                this.props.history.push("/student/home")
              )}
            </>
          )}
        </div>
      </div>
    );
  }
}

export default withRouter(
  compose(
    graphql(FETCH_STUDENTGLOBALS, {
      options: () => ({
        variables: { student_user_exam_id: parseInt(Cookies.get("student_user_exam_id")) },
        fetchPolicy: "network-only",
      }),
      skip: () => !hasEnrollmentId(),
      name: "studentGlobals",
    }),
    graphql(FETCH_ISSTUDENTUSERVALID, {
      options: () => ({
        variables: { student_user_exam_id: parseInt(Cookies.get("student_user_exam_id")) },
        // Shared cache entry; revalidated on navigation by utils/sessionValidity.
        fetchPolicy: "cache-first",
      }),
      skip: () => !hasEnrollmentId(),
      name: "isStudentUserValid",
    })
  )(StudentLoading)
);
